import { baseAPIRequest } from 'utilities/http';

function postRegisterUser (data) {

	const url = '/api/singleprofile/user-profile/register-email/';
	const params = {
		method: 'POST'
	};

	return baseAPIRequest({ url, data, params });

}

export default postRegisterUser;
